import React, { useState } from 'react';
import ReactModal from 'react-modal';
import * as MDICONS from '@material-ui/icons';
import { Link } from "react-router-dom";
import * as ROUTES from '../../../constants/routes';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { openNewProjectPage } from '../../../store/actions/projectActions';
import CreateProjectModal from '../addAndJoin/addProject/CreateProjectModal'


const CreateProjectButton = styled.div`
    .btn {
        color: #fafafa;
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.themeColor};
        margin: 2px;

        &:hover {
            border-color: ${(props) => props.themeColors.themeHoverColor};
            background-color: ${(props) => props.themeColors.themeHoverColor};
        }

        &:active {
            border-color: ${(props) => props.themeColors.themeActiveColor};
            background-color: ${(props) => props.themeColors.themeActiveColor};
        }
    }
`;

const JoinProjectButton = styled.div`
    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.backgroundColor};
        margin: 2px;

        &:hover {
            color: ${(props) => props.themeColors.backgroundColor};
            border-color: ${(props) => props.themeColors.themeHoverColor};
            background-color: ${(props) => props.themeColors.themeHoverColor};
        }

        &:active {
            color: ${(props) => props.themeColors.backgroundColor};
            border-color: ${(props) => props.themeColors.themeActiveColor};
            background-color: ${(props) => props.themeColors.themeActiveColor};
        }
    }
`;


const AddOrJoinButtonBar = (props) => {
    const [controlModal, setControlModal] = useState({ toggle: false });

    const { userData, alu, companyData, modalStyles,project,commons } = props;
    // console.log(project)
    const{isProjectCreated} = project;
    // console.log(isProjectCreationModalOpen,isProjectCreated);
    const { uid, employeeid } = userData;
    const { accessMap } = companyData;

    /// getting ueid to pass into accessMap of company to get accessLevel...
    var ueid = uid + employeeid;
    var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
    var accessBool = alu.newProjectCreationAccess[accessLevel];

    /// creating jsx for relevant button
    var createProjectComponent = accessBool ? (
        <CreateProjectButton themeColors={props.themeColors}>
            <button className="btn btn-default btn-sm" style={{ borderRadius: '10px', marginLeft: '15px' }} onClick={() => { setControlModal({ toggle: true });props.openNewProjectPage() }}>
                <MDICONS.Add /> Create new {commons.project}
            </button>
        </CreateProjectButton>
    ) : (<React.Fragment />)

    return (
        <React.Fragment>
            {/* CONTROL MODAL */}
            <ReactModal
                style={modalStyles} 
                isOpen={controlModal.toggle&&!isProjectCreated}
                onRequestClose={() => { setControlModal({ toggle: false }) }}
                contentLabel="See controls"
                ariaHideApp={false}
            >
                <button className="close" onClick={() => { setControlModal({ toggle: false }) }}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <CreateProjectModal />
            </ReactModal>

            <div className="row">
                {createProjectComponent}

                <Link to={ROUTES.HOME_JOIN_PROJECT}>
                    <JoinProjectButton themeColors={props.themeColors}>
                        <button className="btn btn-default btn-sm" style={{ borderRadius: '15px' }}>
                            <MDICONS.GroupAdd /> Join a {commons.project}
                        </button>
                    </JoinProjectButton>
                </Link>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        userData: state.firebase.profile,
        alu: state.alu,
        companyData: state.firestore.data.Company,
        project: state.project,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        commons:state.commons
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        openNewProjectPage: () => dispatch(openNewProjectPage())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddOrJoinButtonBar);